import { useEffect } from "react";
import confetti from "canvas-confetti";
import { MILESTONE_MAP, STICKERS, STICKER_MAP } from "@/lib/stickers";
import { playMilestone, playSticker } from "@/lib/sounds";

const COLOURS = ["#FF5252", "#FFD166", "#4ECDC4", "#845EC2", "#FF9F43", "#1DD1A1"];
const GOLD = ["#FFD700", "#FFB300", "#FFF1B8", "#CD7F32", "#FFFFFF"];

export function celebrate() {
  confetti({ particleCount: 140, spread: 90, origin: { y: 0.6 }, colors: COLOURS, zIndex: 9999 });
  setTimeout(() => confetti({ particleCount: 70, angle: 60, spread: 70, origin: { x: 0, y: 0.7 }, colors: COLOURS, zIndex: 9999 }), 200);
  setTimeout(() => confetti({ particleCount: 70, angle: 120, spread: 70, origin: { x: 1, y: 0.7 }, colors: COLOURS, zIndex: 9999 }), 350);
}

export function celebrateBig() {
  celebrate();
  const end = Date.now() + 2200;
  const frame = () => {
    confetti({ particleCount: 6, angle: 60, spread: 55, origin: { x: 0, y: 0.8 }, colors: GOLD, zIndex: 9999, shapes: ["star", "circle"] });
    confetti({ particleCount: 6, angle: 120, spread: 55, origin: { x: 1, y: 0.8 }, colors: GOLD, zIndex: 9999, shapes: ["star", "circle"] });
    if (Date.now() < end) requestAnimationFrame(frame);
  };
  setTimeout(frame, 600);
  setTimeout(() => confetti({ particleCount: 220, spread: 360, startVelocity: 40, origin: { y: 0.45 }, colors: GOLD, zIndex: 9999, shapes: ["star"], scalar: 1.4 }), 900);
}

export const StickerReward = ({ reward, onClose }) => {
  const milestone = reward?.milestone ? MILESTONE_MAP[reward.milestone] : null;
  useEffect(() => {
    if (!reward) return;
    if (milestone) { celebrateBig(); playMilestone(); } else { celebrate(); playSticker(); }
    const t = setTimeout(onClose, milestone ? 5200 : 3400);
    return () => clearTimeout(t);
  }, [reward, milestone, onClose]);
  if (!reward) return null;
  const sticker = STICKER_MAP[reward.id] || STICKERS[0];
  const Icon = sticker.icon;
  const MIcon = milestone?.icon;
  return (
    <div className="fixed inset-0 z-[60] flex flex-col items-center justify-center gap-6 bg-black/20 backdrop-blur-[2px]" onClick={onClose} data-testid="sticker-reward">
      {milestone && (
        <div className="sticker-pop flex items-center gap-4 px-8 py-5 rounded-[2rem] border-[6px] border-white shadow-[0_0_0_4px_#1E293B,8px_12px_0_4px_#1E293B]"
          style={{ backgroundColor: milestone.bg }} data-testid="milestone-badge">
          <MIcon className="w-16 h-16 text-[#1E293B]" strokeWidth={2.2} fill="white" />
          <div>
            <p className="font-display text-3xl sm:text-4xl font-bold text-[#1E293B]" data-testid="milestone-badge-text">{milestone.text}</p>
            <p className="font-bold text-[#1E293B]/75">{milestone.blurb} — bonus badge earned!</p>
          </div>
        </div>
      )}
      <div className={`sticker-pop flex flex-col items-center gap-3 px-10 py-8 rounded-[2.5rem] border-[6px] border-white shadow-[0_0_0_4px_#1E293B,8px_12px_0_4px_#1E293B] ${milestone ? "scale-90" : ""}`}
        style={{ backgroundColor: sticker.bg, animationDelay: milestone ? "250ms" : "0ms" }}>
        <Icon className="w-20 h-20 text-[#1E293B]" strokeWidth={2.2} fill="white" />
        <p className="font-display text-3xl sm:text-4xl font-bold text-[#1E293B]" data-testid="sticker-reward-text">{sticker.text}</p>
        <p className="font-bold text-[#1E293B]/70 text-sm" data-testid="sticker-reward-subtext">
          {reward.isNew ? "New sticker added to your shelf!" : "Saved to your library"}
        </p>
      </div>
    </div>
  );
};
